import { Env, readFromEnv } from '@cinch-nx/environments'
import { trackFooterLinkClick } from '../tracking'
import AppleStoreBadge from './assets/app-store-download.svg'
import GooglePlayBadge from './assets/google-play-download.svg'
import styles from './app-store-button.module.css'

interface AppStoreLinkData {
  downloadUrl: string
  ariaLabel: string
  badge: JSX.Element
}

export type AppStores = 'apple-store' | 'google-play'

interface AppStoreButtonProps {
  store: AppStores
}

export const AppStoreButton: React.FC<AppStoreButtonProps> = ({ store }) => {
  const linkData: AppStoreLinkData =
    store === 'apple-store'
      ? {
          downloadUrl: readFromEnv(Env.IOSAppStoreUrl),
          ariaLabel: 'Download on the Apple Store',
          badge: <AppleStoreBadge className={styles.storeButton} />,
        }
      : {
          downloadUrl: readFromEnv(Env.AndroidAppStoreUrl),
          ariaLabel: 'Download on Google Play',
          badge: <GooglePlayBadge className={styles.storeButton} />,
        }

  return (
    <a
      href={linkData.downloadUrl}
      onClick={() =>
        trackFooterLinkClick(linkData.downloadUrl, linkData.ariaLabel)
      }
      target="_blank"
      aria-label={linkData.ariaLabel}
      data-store={store}
    >
      {linkData.badge}
    </a>
  )
}
